import { useConversationStateContext, useConversationDispatchContext } from '../context/ConversationContext';
import { useChatboxStateContext } from '../context/ChatboxContext';
import MessagesTransformer from '../transformers/MessagesTransformer';
import ResponseTransformer from '../transformers/ResponseTransformer';
import VariablesTransformer from '../transformers/VariablesTransformer';
import ServerService from '../services/ServerService';
import ChatboxAction from './ChatboxAction';
import FormData from 'form-data';

function ConversationAction () {

    const { getDataFromServer } = ServerService
    const dispatch = useConversationDispatchContext();

    const { backEndService, company, bot, session, mode, defaultValues, channelKey , currentUrl } = useConversationStateContext();

    const { valueToggleFocus } = useChatboxStateContext();

    const { disableSendMoreMsgToServer, enableSendMoreMsgToServer } = ChatboxAction();

    const sendDataToServer = async (content, isFollowBlock = true) => {

        if(mode != 'client') {
            content.headers = {...content.headers, 'X-Talkr-Analytics-Disable' : '1', 'X-Talkr-Variables-Fetch' : '1'}
        }
        
        if(mode == 'debug') {
            content.headers = {...content.headers, 'X-Talkr-Debug' : '1'}
        }

        if (content.body && content.body.file) {
            const formData = new FormData();
            for (const key in content.body) {
                formData.append(key, content.body[key]);
            }
            content.body = formData;
        }
        
        dispatch({ type : 'setLoading',payload : {response : true}});

        const body = await getDataFromServer( { backEndService, company, bot }, content);
        if (body.error == true){
            dispatch({ type : 'setLoading',payload : {response : "error"}});
            return body.error
        }
        enableSendMoreMsgToServer();
        var { data, language, session, success, variables, path} = body;
        var { messages, responses, object_id ,type, ...rest } = data;
        /*
        if(data == undefined && status == 500) {
            messages = [ { content : body.message } ];
        }*/
        if(window.followBlock && valueToggleFocus && isFollowBlock) {
            window.followBlock(object_id)
        }
        path = path == undefined ? [] : path
        responses = ResponseTransformer(responses);
        variables = VariablesTransformer(variables);

        messages = MessagesTransformer(messages);

        window.localStorage.setItem('talkr_session', session);

        dispatch({ type : 'setLoading',payload : {response : false}});
        dispatch( { type : 'init', payload : { session, rest, language, path }})
        dispatch( { type : 'addMessagesAndResponsesAndVariableIfPresent', payload : { messages, responses, variables }})
     
        if (type == "announcement"){ // chatbox editor only
            askBotNextQuestion(rest.redirect);
        }
    }
    
    const refreshDeeplyConversation = () => {
        dispatch({ type : 'restartConversation'});
        getBotFirstQuestion(true);
    }

    const restartConversation = () => {
        dispatch({ type : 'restartConversation'});
        getBotFirstQuestion();
    }

    const getBotFirstQuestion = async (refreshDeep = false) => {

        const content = { method: 'post', body : {}, headers : { 'X-Talkr-Variables-Reset' : '1' } };

        content.body.refreshDeep = refreshDeep; 
        if(session) {
            content.body.session = session;
        }

        if(currentUrl){
            content.body.currentUrl = currentUrl;
        }

        if(channelKey) {
            content.headers = {'X-Talkr-Channel-Key' : channelKey}
        }
        content.body.storage = localStorage;
        // Implement token functionnality
        const token = null
        if(token) {
            content.body.token = token;
        }
        
        if(defaultValues.variables && typeof defaultValues.variables === 'object' && defaultValues.variables != null) {
            content.body.variables = defaultValues.variables;
        }

        const isFollowBlock = !window.location.hash.slice(1);

        sendDataToServer(content, isFollowBlock)
    }

    const askBotNextQuestion = async (tracking, data) => {
        disableSendMoreMsgToServer();
        const content = { method: 'post', body : { session, tracking , currentUrl, storage : localStorage} };

        if(channelKey) {
            content.headers = {'X-Talkr-Channel-Key' : channelKey}
        }

        const isDataSendFile = typeof data === 'object';
        const text = isDataSendFile ? data.name : data;

        if(text) {
            isDataSendFile ? content.body.file = data : content.body.text = text;
            dispatch( { type : 'addMessage', payload : { message : { content : text, type : 'human', view : 1} }})
        }

        sendDataToServer(content);
    }

    return { getBotFirstQuestion, askBotNextQuestion, restartConversation,refreshDeeplyConversation }

}

export default ConversationAction;